import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getAllBlogCategory } from "../../redux/actions/indexActions";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";

const AddBlogCategory = () => {
  const [formData, setFormData] = useState({
    type: 1,
    category_name: "",
    parent: "",
    status: 1,
    thumbnail: "",
  });
  const [errors, setErrors] = useState({});
  const [blogCategories, setBlogCategories] = useState([]);
  const {
    AuthReducer: { auth }
  } = useSelector((state) => state);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllBlogCategory(auth.token));
  }, [auth]);

  useEffect(() => {
    if (formData.type) {
      axios(`/api/admin/v1/all-blog-category/?type=${formData.type}`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      })
        .then(({ data }) => {
          setBlogCategories(data?.BlogCategories);
        })
        .catch((err) => console.error(err));
    } else {
      setBlogCategories([]);
    }
  }, [formData.type]);

  const inputHandler = (e) => {
    const { name, value } = e.target;
    if (name === "thumbnail") {
      setFormData({ ...formData, [name]: e.target.files[0] });
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleSubmit = () => {
    const form = new FormData();
    // for (const key in formData) {
    //   form.append([key], formData[key]);
    // }
    form.append('type', formData.type);
    form.append('category_name', formData.category_name);
    form.append('parent', formData.parent);
    form.append('thumbnail', formData.thumbnail);
    form.append('status', formData.status);
    // console.log(formData);
    axios
      .post(`/api/admin/v1/add-blog-category`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };


  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h4 className="text-white">Add Blog Category</h4>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Type<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.type}
                type="select"
                name="type"
                onChange={inputHandler}
              >
                <option value="">Select Type</option>
                <option value="1">Blog</option>
                <option value="2">Event</option>
                <option value="3">Resource</option>
              </Input>
              <span className="d-block text-danger"> {errors?.type} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Category Name <span className="text-danger fs-4">*</span></Label>
              <Input
                invalid={Boolean(errors?.category_name)}
                value={formData?.category_name}
                name="category_name"
                onChange={inputHandler}
              />
              <span className="d-block text-danger"> {errors?.category_name} </span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Parent Category</Label>
              <Input
                value={formData?.parent}
                type="select"
                name="parent"
                onChange={inputHandler}
              >
                <option value="">Select Option</option>
                {blogCategories?.map?.((item) => {
                  return (
                    <option value={item.id} key={item.id}>
                      {item?.category_name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.parent}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Upload Thumbnail</Label>
              <Input
                type="file"
                invalid={Boolean(errors?.thumbnail)}
                name="thumbnail"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [e.target.name]: e.target.files[0],
                  }))
                }
              />
              <span className="d-block text-danger">{errors?.thumbnail}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddBlogCategory;
